module.exports = __webpack_public_path__ + "static/img/slogan_studio.d47e5a1a.svg";